import { LoadingSpinner } from '../../components/LoadingSpinner/LoadingSpinner'
import { navigate, useMatch } from '@reach/router'
import React, { useEffect } from 'react'
import { useEligibilityCheck } from '../../hooks/useEligibilityCheck'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import {
  selectCreateSuccessState,
  setCreateGroup,
} from '../../store/slices/sheetsSlice'
import CreatePool from './createPool'
import SheetWrapper from '../../components/SheetWrapper'
import CreateSuccess from './CreateSuccess'
import { HOME_PATH } from '../../constants'

const CreateScreen = ({
  isCreateGroupFlow,
  redirectHomeAfterClosing = true,
  onCloseComplete,
}: {
  isCreateGroupFlow?: boolean
  redirectHomeAfterClosing?: boolean
  onCloseComplete?: () => void
}) => {
  /*
  isCreateGroup is used so that we can include this component, but not show it until we need it.
  This allows us to make the sheet animate in and out nicely.
   */
  const dispatch = useAppDispatch()
  const {
    isEligible,
    isSuccess: isEligibleSuccess,
    isFetching,
    isRedirecting,
  } = useEligibilityCheck(isCreateGroupFlow)
  const isCreateGroupScreen = useAppSelector(({ sheets }) => sheets.createGroup)
  const isSuccessOpen = useAppSelector(selectCreateSuccessState)
  const routeParams = useMatch(`${HOME_PATH}/:groupId`)
  const isGroupDetailPage = !!routeParams?.groupId
  const isCreateSuccessShown = useAppSelector(
    ({ sheets }) => sheets.createSuccess,
  )
  /*
  This is executed when the Create screen is loaded via /groups/create
  If user isn't eligible, navigate to /groups
  When we resume the create flow after Step-Up, don't navigate back if only the success screen will render
   */
  if (
    isCreateGroupFlow &&
    isEligibleSuccess &&
    !isEligible &&
    !isGroupDetailPage
  ) {
    navigate(HOME_PATH)
  }

  useEffect(() => {
    if (isCreateGroupFlow && isEligible) {
      dispatch(setCreateGroup(true))
    }
  }, [isCreateGroupFlow, isEligible])

  return (
    <>
      <SheetWrapper
        title="Create a new Group" // TODO: replace with content string
        onCloseComplete={null}
        isOpen={(isCreateGroupFlow && !isEligibleSuccess) || isRedirecting}
        data-testid="create-screen-loader"
      >
        {/* Used when loading component directly from /groups/create */}
        <LoadingSpinner size="xl" />
      </SheetWrapper>

      {isCreateGroupFlow && (
        <CreatePool
          isOpen={isCreateGroupScreen && !isSuccessOpen}
          isLoading={isFetching}
          redirectHomeAfterClosing={redirectHomeAfterClosing}
          onCloseComplete={onCloseComplete}
        />
      )}
      {isCreateSuccessShown && <CreateSuccess isOpen={isSuccessOpen} />}
    </>
  )
}

export default CreateScreen
